import { css } from '@emotion/react';
import styled from '@emotion/styled';
import CharacterLikedCount from '../CharacterLikedCount/CharacterLikedCount';

interface CharacterInfoProps {
  name: string;
  desc: string;
  liked_count: number;
}

export default function CharacterInfo({
  name,
  desc,
  liked_count,
}: CharacterInfoProps) {
  return (
    <CharacterInfoBox>
      <Name>{name}</Name>
      <Desc>{desc}</Desc>
      <CharacterLikedCount liked_count={liked_count} />
    </CharacterInfoBox>
  );
}

export const CharacterInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  justify-content: flex-end;
  height: 92px;
  gap: 4px;
`;

const Name = styled.h3`
  ${({ theme }) => css`
    display: block;
    ${theme.mixins.text.ellipsis_1};
    width: 100%;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

const Desc = styled.p`
  ${({ theme }) => css`
    display: block;
    flex: 1;
    width: 100%;
    color: ${theme.content.content_light_3};
    ${theme.mixins.text.ellipsis_2};
    ${theme.fontStyle.text.caption_medium};
  `}
`;
